import React from 'react';
import { isWeixin, isWeixinWork } from '../../../utils/common';
import './index.scss';
export const ImageInfo = props => {
	return (
		<div className="common-image-info">
			<div className="content">
				<header>
					<span>{props.isVideo ? '视频信息' : '照片信息'}</span>
					<div className="right" onClick={props.clickIcon}>
						<span className="license-wrapper">
							<i className="iconfont cc-icon">&#xe65a;</i>
							<i className="iconfont by-icon">&#xe659;</i>
						</span>
						<span className="arrow-wrapper">
							<i className="iconfont arrow">&#xe655;</i>
						</span>
					</div>
				</header>
				{typeof props.text === 'string' ? <div className="text" dangerouslySetInnerHTML={{ __html: props.text }}></div> : <div className="text">{props.text}</div>}
				<footer onClick={props.clickFooter}>{props.footer}</footer>
			</div>
		</div>
	);
};
